import { DICT } from '@/common/utils/dict'
import { imgRegularFn } from '@/common/utils/tool'
// 基础信息
export const baseInfo = [
  {
    title: '基础信息',
    column: [
      { label: '订单编号', prop: 'orderId' },
      { label: '揽收时间', prop: 'deliveryTime' },
      { label: '订单来源', prop: 'orderSourceName' },
      { label: '物品类型', prop: 'goodsTypeName' },
      { label: '物品名称', prop: 'goodsName' },
      { label: '产品类型', prop: 'expressTypeName' },
      { label: '订单标签', prop: 'orderSignName', slot: true }
    ]
  },
  {
    title: '寄件信息',
    decode: true,
    column: [
      { label: '面单发放网点', prop: 'pickUpNetworkName' },
      { label: '寄件网点', prop: 'pickNetworkName' },
      { label: '寄件客户', prop: 'customerName' },
      { label: '寄件姓名', prop: 'senderName' },
      {
        label: '寄件地址', prop: 'senderFullAddress',
        formatter({ senderCountryName, senderProvinceName, senderCityName, senderAreaName, senderDetailedAddress, senderStreet, senderTownship }) {
          return `
          ${senderCountryName || ''}
          ${senderProvinceName || ''}
          ${senderCityName || ''}
          ${senderAreaName || ''}
          ${senderDetailedAddress || ''}
          ${senderStreet || ''}
          ${senderTownship || ''}`
        }
      },
      { label: '寄件电话', prop: 'senderMobilePhone' }
    ]
  },
  {
    title: '收件信息',
    decode: true,
    column: [
      { label: '收件网点', prop: 'dispatchNetworkName' },
      { label: '收件姓名', prop: 'receiverName' },
      {
        label: '收件地址', prop: 'receiverFullAddress',
        formatter({ receiverCountryName, receiverProvinceName, receiverCityName, receiverAreaName, receiverDetailedAddress, receiverStreet, receiverTownship, addressDetail }) {
          if (addressDetail&&addressDetail!==true) return addressDetail// 有详细地址时取详细地址}) {
          return `
          ${receiverCountryName || ''}
          ${receiverProvinceName || ''}
          ${receiverCityName || ''}
          ${receiverAreaName || ''}
          ${receiverDetailedAddress || ''}
          ${receiverStreet || ''}
          ${receiverTownship || ''}`
        }
      },
      { label: '虚拟号码', prop: 'virtualNumber', decode:true , type:3 },
      { label: '收件电话', prop: 'receiverMobilePhone' }
    ]
  },
  {
    title: '结算信息',
    column: [
      { label: '计费重量', prop: 'packageTotalWeight' },
      {
        label: '长/宽/高', prop: 'packageSize', formatter({ packageLength, packageWide, packageHigh }) {
          packageLength += ''
          packageWide += ''
          packageHigh += ''
          if (isNaN(packageLength) && isNaN(packageWide) && isNaN(packageHigh)) {
            return '--'
          }
          return `${packageLength || '--'}/${packageWide || '--'}/${packageHigh || '--'}`
        }
      },
      { label: '体积重', prop: 'packageVolume' },
      { label: '结算方式', prop: 'settlementName' }
    ]
  },
  {
    title: '三段码',
    column: [
      {
        label: '一段码', prop: 'terminalDispatchCode1', formatter: ({ terminalDispatchCode = '' }) => {
          return terminalDispatchCode ? terminalDispatchCode.split(',')[0] : ''
        }
      },
      {
        label: '二段码', prop: 'terminalDispatchCode2', formatter: ({ terminalDispatchCode = '' }) => {
          return terminalDispatchCode ? terminalDispatchCode.split(',')[1] : ''
        }
      },
      {
        label: '三段码', prop: 'terminalDispatchCode3', formatter: ({ terminalDispatchCode = '' }) => {
          return terminalDispatchCode ? terminalDispatchCode.split(',')[2] : ''
        }
      }
    ]
  },
  {
    title: '其他信息',
    column: [
      {
        label: '退件标识', prop: 'isRefund', formatter: ({ isRefund }) => {
          const labels = ['否', '是', '已转件', '转退件']
          return labels[isRefund]
        }
      },
      {
        label: '签收标识', prop: 'isSign', formatter: ({ isSign }) => {
          const labels = ['否', '正常签收', '退件签收']
          return labels[isSign]
        }
      },
      { label: '回单编号', prop: 'receiptNo' },
      {
        label: '问题标识', prop: 'isAbnormal', formatter: ({ isAbnormal }) => {
          const labels = ['否', '是']
          return labels[isAbnormal]
        }
      },
      {
        label: '作废标识', prop: 'isVoid', formatter: ({ isVoid }) => {
          const labels = ['否', '是']
          return labels[isVoid]
        }
      }
    ]
  }
]

// 处理记录
export const handle = {
  head: [
    [
      {
        label: '处理机构',
        labelWidth: 70,
        width: 200,
        prop: 'operationNetworkName'
      },
      {
        label: '处理时间',
        labelWidth: 70,
        prop: 'operationTime'
      }
    ],
    [
      {
        label: '处理人',
        labelWidth: 70,
        width: 200,
        prop: 'operatorName'
      },
      {
        label: '处理类型',
        labelWidth: 70,
        prop: 'type',
        formatter({ type }) {
          const dict = {
            '1': '工单登记',
            '2': '工单分配',
            '3': '工单申领',
            '4': '工单关闭',
            '5': '继续处理',
            '6': '工单升级',
            '7': '工单催单',
            '8': '暂不处理',
            '9': '工单定责',
            '10': '极速理赔',
            '11': '网点理赔审核通过',
            '12': '网点理赔审核驳回',
            '13': '极速理赔审核通过',
            '14': '极速理赔审核驳回',
            '15': '转理赔工单',
            '16': '转网点处理',
            '17': '总部升级',
            '18': '转总部工单'
          }
          return dict[type]
        }
      }
    ],
    [
      {
        label: '指定受理网点',
        labelWidth: 90,
        width: 200,
        prop: 'acceptNetworkName',
        formatter: ({ acceptNetworkName }) => acceptNetworkName || '--'
      },
      {
        label: '责任网点',
        labelWidth: 70,
        prop: 'dutyNetworkName',
        formatter: ({ dutyNetworkName }) => dutyNetworkName || '--'
      }
    ]
  ],
  column: [
    {
      label: '催单原因',
      labelWidth: 80,
      prop: 'reminderReason',
      hide({ reminderReason }) {
        return reminderReason
      },
      formatter({ reminderReason }) {
        const item = DICT.urgeReason.find(o => o.value === reminderReason) || {}
        return item.label
      }
    },
    {
      label: '处理意见',
      labelWidth: 80,
      prop: 'handlingOpinions'
    },
    {
      label: '',
      labelWidth: 80,
      img: true,
      prop: 'paths',
      formatter({ urls }) {
        urls = urls || []
        return urls.map((url, key) => {
          let icon = ''
          if (~url.indexOf('.pdf')) {
            icon = 'iconPDF'
          } else if (~url.indexOf('.docx')) {
            icon = 'icondocx1'
          } else if (~url.indexOf('.doc')) {
            icon = 'icondoc1'
          } else if (~url.indexOf('.zip')) {
            icon = 'iconyasuobao'
          } else if (~url.indexOf('.rar')) {
            icon = 'iconRAR'
          } else if (!url.match(/\.(jpe?g|png|gif)/)) {
            icon = 'icongonggaoguanli-wendang'
          }
          return {
            id: key,
            icon,
            url
          }
        })
      }
    }
  ]
}

// 物流轨迹
export const trail = {
  showNetInfo: false,
  abnormalTask: false,
  showStopList: false,
  showPackInfo: false,
  width: '660px',
  head: [
    // { label: '序号', style: { width: '50px' }, prop: 'index' },
    { label: '扫描时间', style: { width: '78px' }, prop: 'scanTime', html: true, formatter: ({ scanTime }) => scanTime.replace(/\s/, '<br>'), slotTitle: true },
    { label: '扫描类型', style: { width: '60px' }, prop: 'scanTypeName' },
    { label: '跟踪记录描述', style: { flex: '1 1' }, prop: 'waybillTrackingContent' },
    {
      label: '扫描网点', style: { width: '160px' }, prop: 'scanNetworkName',
      formatter: ({ scanNetworkName: name, scanNetworkCode: code }) => name && code ? `${name} | ${code}` : name
    },
    { label: '图片', prop: 'showImg', width: '80px' }
  ]
}

// 问题记录
export const problem = {
  width: '1800px',
  head: [
    { style: { width: '76px', padding: 0 }, prop: 'detailIcon' },
    { label: '登记时间', style: { width: '75px' }, prop: 'createTime' },
    { label: '登记网点', style: { width: '100px' }, prop: 'registrationNetworkName' },
    { label: '问题件类型', style: { width: '80px' }, prop: 'probleTypeSubjectName' },
    { label: '问题件原因', style: { flex: 1 }, prop: 'probleDescription' },
    { label: '问题件图片', style: { width: '70px' }, prop: 'urls', slot: true },
    { label: '最新回复内容', style: { flex: 1 }, prop: 'lastReplyContent' },
    {
      label: '问题件状态', style: { width: '70px' }, prop: 'problePieceStatus', formatter({ problePieceStatus }) {
        const dict = ['登记方已登记', '登记方已回复', '接收方已回复', '已转投诉件', '已完结']
        return dict[problePieceStatus - 1] || ''
      }
    },
    { label: '登记人', style: { width: '50px' }, prop: 'createByName' },
    { label: '操作类型', style: { width: '60px' }, prop: 'probleTypeName' },
    { label: '接收网点', style: { width: '70px' }, prop: 'receiveNetworkName' },
    { label: '接收中心', style: { width: '60px' }, prop: 'receiveNetworkParentName' },
    {
      label: '问题件来源 ', style: { width: '70px' }, prop: 'problePieceSource', formatter({ problePieceSource }) {
        const dict = ['JMS系统', '巴枪app', 'PC', '共配']
        return dict[problePieceSource - 1]
      }
    }
  ]
}

// 问题记录回复
export const problemMin = {
  head: [
    { label: '序号', style: { width: '30px' }, prop: 'index' },
    { label: '回复网点', style: { width: '100px' }, prop: 'replyNetworkName' },
    { label: '回复时间', style: { width: '75px' }, prop: 'createTime' },
    { label: '回复人', style: { width: '50px' }, prop: 'createByName' },
    { label: '回复人手机号', style: { width: '75px' }, prop: 'replyPhone' },
    { label: '回复内容', style: { width: '600px' }, prop: 'replyContent' },
    { label: '回复附件', prop: 'urls', style: { width: '100px' }, slot: true }
  ]
}

// 工单/理赔
export const workOrder = {
  width: '1400px',
  head: [
    { style: { width: '76px', padding: 0 }, prop: 'detailIcon' },
    {
      label: '工单类型', style: { width: '60px' }, prop: 'workOrderType', formatter({ workOrderType }) {
        const dict = ['-', '普通工单', '理赔工单', '项目工单', '问题记录','-','事件工单']
        return dict[workOrderType]
      }
    },
    { label: '登记网点', style: { width: '100px' }, prop: 'registrationNetworkName' },
    { label: '登记时间', style: { width: '70px' }, prop: 'createTime' },
    { label: '来访对象', style: { width: '60px' }, prop: 'customerName' },
    {
      label: '来访对象类型', style: { width: '85px' }, prop: 'customerType', toggle: true, formatter({ customerType }) {
        const dict = ['寄件人', '收件人', '其他']
        return dict[customerType - 1]
      }
    },
    { label: '来电号码', style: { width: '75px' }, prop: 'customerPhone', toggle: true },
    { label: '回电号码', style: { width: '75px' }, prop: 'callBackPhone', toggle: true },

    { label: '一级问题类型', style: { width: '85px' }, prop: 'firstTypeName', toggle: true },
    { label: '二级问题类型', style: { width: '85px' }, prop: 'secondTypeName' },
     { label: '问题标签', style: { flex: 1 }, prop: 'labelList', formatter({ labelList }) {
      return (labelList || []).join('，') || '--'
    } },
    {
      label: '工单状态', style: { width: '60px' }, prop: 'status', formatter({ status }) {
        const dict = ['待处理', '待分配', '处理中', '已关闭']
        return dict[status]
      }
    },
    { label: '登记人', style: { width: '75px' }, prop: 'createByName', toggle: true },
    { label: '工单登记人', style: { width: '75px' }, prop: 'serviceRegistrantName', toggle: true },
    { label: '问题描述', style: { flex: 1 }, prop: 'problemDescription' },
    { label: '投诉内容', style: { flex: 1 }, prop: 'complaintDesc' }
  ]
}

// 工单/理赔记录回复
export const workOrderMin = {
  head: [
    { label: '处理机构', style: { width: '150px' }, prop: 'operationNetworkName' },
    { label: '处理时间', style: { width: '200px' }, prop: 'operationTime' },
    { label: '处理人', style: { width: '100px' }, prop: 'operatorName' },
    { label: '处理意见', style: { width: '600px' }, prop: 'handlingOpinions' },
    { label: '处理附件', style: { width: '70px' }, isPaths: true, prop: 'enclosure', type: 'enclosure' }
  ]
}

// 仲裁
export const arbitration = {
  width: '2100px',
  head: [
    { label: '序号', style: { width: '30px' }, prop: 'index' },
    { label: '申报网点', style: { width: '100px' }, prop: 'createNetworkName' },
    { label: '申报时间', style: { width: '70px' }, prop: 'createTime' },
    { label: '一级异常类型', prop: 'firstType' },
    { label: '二级异常类型', prop: 'secondType' },
    { label: '异常说明', style: { flex: 1 }, prop: 'exceptionDesc' },
    { label: '责任网点', style: { width: '100px' }, prop: 'responsibilityNetworkName' },
    {
      label: '仲裁状态', prop: 'status', formatter({ status }) {
        const dict = ['责任方处理中', '已撤销', '待仲裁分配', '仲裁受理中', '仲裁核实中', '仲裁退回', '仲裁裁定完成', '申诉受理中', '申诉核实中', '已结案']
        return dict[status - 1] || ''
      }
    },
    { label: '结案时间', style: { width: '75px' }, prop: 'closingTime' },
    { label: '仲裁处理意见', style: { flex: 1 }, prop: 'arbitrationAdjudicateOpinion' },
    { label: '申诉处理意见', style: { flex: 1 }, prop: 'appealAdjudicateOpinion' }
  ]
}

// 质量
export const quality = {
  width: '1600px',
  head: [
    { style: { width: '76px', padding: 0 }, prop: 'detailIcon' },
    {
      label: '质量工单状态', style: { width: '150px' }, prop: 'workOrderStatus', formatter({ workOrderStatus }) {
        const item = DICT.Q_status.find(o => o.value === workOrderStatus) || {}
        return item.label
      }
    },
    { label: '申报时间', style: { width: '75px' }, prop: 'createTime' },
    { label: '一级类型', prop: 'problemTypeName' },
    { label: '二级类型', prop: 'problemTypeSubjectName' },
    { label: '申报网点', prop: 'applyNetworkName' },
    { label: '奖励金额', prop: 'awardAmount' },
    { label: '申报代理区', prop: 'applyProxyNetworkName' },
    { label: '责任网点', prop: 'responsibleNetworkName' },
    { label: '惩罚金额', prop: 'penaltyAmount' },
    { label: '责任代理区', prop: 'responsibleProxyNetworkName' },
    { label: '问题描述', style: { flex: 1 }, prop: 'problemDescription' },
    { label: '查看图片', style: { width: '70px' }, prop: 'urls', slot: true }
  ]
}

// 质量记录回复
export const qualityMin = {
  head: [
    { label: '操作节点', prop: 'fromNetworkName' },
    { label: '操作人', prop: 'processorName' },
    { label: '联系方式', prop: 'contactInformation' },
    { label: '流向节点', prop: 'toNetworkName' },
    {
      label: '操作类型', prop: 'operationType', formatter({ operationType }) {
        const item = DICT.Q_operationType.find(o => o.value === operationType) || {}
        return item.label
      }
    },
    { label: '惩罚金额', prop: 'penaltyAmount' },
    { label: '奖励金额', prop: 'awardAmount' },
    { label: '操作时间', style: { width: '150px' }, prop: 'createTime' },
    { label: '处理原因', style: { flex: 1 }, prop: 'processorOpinions' },
    { label: '问题件附件', style: { width: '90px' }, urlProp: 'problemPieceAttachment', prop: 'urls', isPaths: true, slot: true },
    { label: '举证附件', style: { width: '70px' }, urlProp: 'proofAttachment', prop: 'files', isPaths: true, slot: true }
  ]
}

// 来电记录
export const CallRecords = {
  width: '800px',
  head: [
    // {
    //   label: '会话ID',
    //   sortable: false,
    //   prop: 'sessionId'
    // },
    {
      label: '记录时间',
      sortable: false,
      prop: 'createTime',
      style: { width: '178px' }
    },
    {
      label: '来电号码',
      prop: 'callPhone',
      style: { width: '178px' }
    },
    {
      label: '回电号码',
      prop: 'callBackPhone',
      style: { width: '178px' }
    },
    {
      label: '运单号',
      sortable: false,
      prop: 'waybillNo',
      style: { width: '178px' }
    },
    {
      label: '一级问题类型',
      sortable: false,
      prop: 'firstTypeName',
      style: { width: '178px' }
    },
    {
      label: '二级问题类型',
      sortable: false,
      prop: 'secondTypeName',
      style: { width: '178px' }
    },

    {
      label: '来访对象',
      sortable: false,
      prop: 'callPerson',
      style: { width: '78px' }
    },
    {
      label: '来电方',
      prop: 'callFrom',
      formatter({ callFrom }) {
        const dict = ['', '寄件人', '收件人', '其他']
        return dict[callFrom] || ''
      }
    },
    {
      label: '进线方式',
      prop: 'callType',
      formatter({ callType }) {
        const dict = ['','热线电话', '在线客服','其他']
        return dict[callType] || ''
      }
    },
    {
      label: '接待人',
      prop: 'registrant'
    },
    {
      label: '登记网点',
      prop: 'registrationNetworkName'
    }
  ]
}

// 短信记录
export const SmsLogs = {
  width: '800px',
  head: [
    {
      label: '发送时间',
      sortable: false,
      prop: 'createTime',
      style: { width: '178px' }
    },
    {
      label: '发送号码',
      prop: 'phone',
      style: { width: '178px' }
    },
    {
      label: '运单号',
      sortable: false,
      prop: 'waybillNo',
      style: { width: '178px' }
    },
    {
      label: '发送人',
      sortable: false,
      prop: 'createByName',
      style: { width: '98px' }
    },
    {
      label: '发送状态',
      prop: 'msgStatus',
      formatter({ msgStatus }) {
        const dict = ['失败', '成功']
        return dict[msgStatus] || ''
      }
    },
    {
      label: '发送内容',
      prop: 'content',
      style: { width: '350px' }
    },
    {
      label: '发送结果说明',
      prop: 'remark',
      style: { width: '120px' }
    }
  ]
}

// 百世物流轨迹
export const immortalTrail = {
  width: '800px',
  head: [
    {
      label: '扫描时间',
      sortable: false,
      prop: 'acceptTime',
      style: { width: '130px' }
    },
    // {
    //   label: '城市',
    //   sortable: false,
    //   prop: 'acceptAddress',
    //   style: { width: '130px' }
    // },
    {
      label: '操作记录',
      sortable: false,
      prop: 'remark',
      style: { width: '478px' }
    },
    {
      label: '扫描类型',
      sortable: false,
      prop: 'scanType',
      style: { width: '78px' }
    }
  ]
}

// 邮政工单外层
export const postalOrder = {
  width: '1200px',
  head: [
    { label: '序号', style: { width: '76px', padding: 0 }, prop: 'detailIcon' },
    {
      label: '申诉编号',
      style: { width: '140px' },
      prop: 'appealNo'
    },
    { label: '运单号', style: { width: '120px' }, prop: 'waybillNo' },
    { label: '处理状态', style: { width: '70px' }, prop: 'statusStr' },
    { label: '登记时间', style: { width: '130px' }, prop: 'complaintTime' },
    {
      label: '申诉人',
      style: { width: '85px' },
      prop: 'userName'
    },
    { label: '申诉人手机号', style: { width: '100px' }, prop: 'phone' },
    { label: '受理方', style: { width: '85px' }, prop: 'acceptNetworkName' },
    { label: '问题描述', style: { width: '200px' }, prop: 'description' },
    {
      label: '申诉原因',
      style: { width: '60px' },
      prop: 'causeStr'
    }
  ]
}

// 邮政工单里层
export const postalOrderMin = {
  head: [
    { label: '处理机构', style: { width: '100px' }, prop: 'processNetworkName' },
    { label: '处理时间', style: { width: '200px' }, prop: 'createTime' },
    { label: '处理人', style: { width: '60px' }, prop: 'processByName' },
    { label: '处理意见', style: { width: '600px' }, prop: 'content' }
  ]
}
// 基础信息
export const baseInfoTable = {
  head: [
    {
      label: "寄件网点",
      prop: "pickNetworkName",
    },
    {
      label: "寄件人电话",
      prop: "senderMobilePhone",
      // decode: true,
      style: { width: "120px" },
    },
    {
      label: "寄件地址",
      prop: "senderFullAddress",
      style: { width: "20%" },
      formatter({
        senderCountryName,
        senderProvinceName,
        senderCityName,
        senderAreaName,
        senderDetailedAddress,
        senderStreet,
        senderTownship,
      }) {
        return `
        ${senderCountryName || ""}
        ${senderProvinceName || ""}
        ${senderCityName || ""}
        ${senderAreaName || ""}
        ${senderDetailedAddress || ""}
        ${senderStreet || ""}
        ${senderTownship || ""}`;
      },
    },
    {
      label: "目的网点",
      prop: "dispatchNetworkName",
    },
    {
      label: "收件人电话",
      prop: "receiverMobilePhone",
      style: { width: "120px" },
      // decode: true,
    },
    {
      label: "收件地址",
      prop: "receiverFullAddress",
      style: { width: "20%" },
      formatter({
        receiverCountryName,
        receiverProvinceName,
        receiverCityName,
        receiverAreaName,
        receiverDetailedAddress,
        receiverStreet,
        receiverTownship,
      }) {
        return `
          ${receiverCountryName || ""}
          ${receiverProvinceName || ""}
          ${receiverCityName || ""}
          ${receiverAreaName || ""}
          ${receiverDetailedAddress || ""}
          ${receiverStreet || ""}
          ${receiverTownship || ""}`;
      },
    },
    {
      label: "操作",
      prop: "operation",
      slot: true,
    },
  ],
};

// 质检处理记录
export const handleQt = {
  head: [
    [
      {
        label: '处理机构',
        labelWidth: 70,
        width: 200,
        prop: 'opOrgType',
        formatter({ opOrgType }) {
          const dict = {
            'CP': '系统',
            'HEADQUARTERS': '总部',
            'NETWORK': '网点',
            'AGENT_AREA': '代理区',
            'BPO': '服务商'
          }
          return dict[opOrgType]
        }
      },
      {
        label: '处理时间',
        labelWidth: 70,
        prop: 'createTime'
      }
    ],
    [
      {
        label: '处理人',
        labelWidth: 70,
        width: 200,
        prop: 'opName',
        formatter({ opName, opCode }) {
          return `${opName}/${opCode}`
        }
      },
      {
        label: '处理类型',
        labelWidth: 70,
        prop: 'opType',
        formatter({ opType }) {
          const dict = {
            'TASK_INIT': '任务生成',
            'CP_RECHECKED': '首次质检',
            'RECHECK_ASSIGN': '人工复检分配',
            'RECHECKED': '提交人工复检',
            'APPEAL': '发起申诉',
            'APPEAL_RECHECK_ASSIGN': '申诉复检分配',
            'APPEAL_RECHECKED': '提交申诉复检',
            'CLOSE': '完结'
          }
          return dict[opType]
        }
      }
    ]
  ],
  column: [
    {
      label: '描述',
      labelWidth: 80,
      prop: 'remark',
      formatter({ remark }) {
        const remarkDeal = remark
        return remarkDeal
      }
    },
    {
      label: '',
      labelWidth: 80,
      img: true,
      prop: 'files',
      formatter({ files }) {
        files = files || []
        return imgRegularFn(files)
      }
    }
  ]
}


// 取件码
export const Pickupcode = {
  width: '800px',
  // 短信发送时间=请求时间、发送号码=接收手机号、运单号=运单号、发送人=客服名称、发送状态=请求结果、发送结果说明=请求说明、发送内容=默认“-”
  head: [
    {
      label: '短信发送时间',
      sortable: false,
      prop: 'requestTime',
      style: { width: '178px' }
    },
    {
      label: '发送号码',
      sortable: false,
      prop: 'addresseePhone',
      style: { width: '178px' }
    },
    {
      label: '运单号',
      sortable: false,
      prop: 'billCode',
      style: { width: '178px' }
    },
    {
      label: '发送人',
      sortable: false,
      prop: 'operatorName',
      style: { width: '178px' }
    },
    {
      label: '发送状态',
      sortable: false,
      prop: 'requestResultStr',
      style: { width: '178px' }
    },
    {
      label: '发送结果说明',
      sortable: false,
      prop: 'requestDesc',
      style: { width: '178px' }
    },
    {
      label: '发送内容',
      sortable: false,
      prop: 'requestContent',
      formatter({ requestContent }) {
        return requestContent || '-'
      }
    }
  ]
}

// 任务工单
export const orderTask = {
  width: '1400px',
  head: [
    { style: { width: '76px', padding: 0 }, prop: 'detailIcon' },
    { label: '登记网点', style: { width: '100px' }, prop: 'registrationNetworkName' },
    { label: '任务生成时间', prop: 'createTime' },
    {
      label: '任务单状态',
      style: { width: '100px' },
      prop: 'status',
      formatter({ status }) {
        const dict = ['待处理', '待分配', '处理中', '已关闭']
        return dict[status]
      }
    },
    { label: '来访对象', style: { width: '60px' }, prop: 'customerName' },
    {
      label: '来访对象类型',
      style: { width: '85px' },
      prop: 'customerType',
      formatter({ customerType }) {
        const dict = ['寄件人', '收件人', '其他']
        return dict[customerType - 1]
      }
    },
    { label: '来电号码', style: { width: '75px' }, prop: 'customerPhone' },
    { label: '一级问题类型', style: { width: '85px' }, prop: 'firstTypeName' },
    { label: '二级问题类型', style: { width: '85px' }, prop: 'secondTypeName' },
    { label: '登记人', style: { width: '75px' }, prop: 'createByName' },
    { label: '问题描述', style: { flex: 1 }, prop: 'problemDescription' }
  ]
}
